module.exports = __webpack_public_path__ + "static/media/onions-explore-more.31833ddb.jpg";